import * as z from "zod/v4";

export const getAeoPromptDetails = {
  name: "getAeoPromptDetails" as const,
  input: z.object({ promptId: z.bigint() }),
  output: z
    .object({
      id: z.bigint(),
      prompt: z.string(),
      category: z.string(),
      createdAt: z.string(),
      deletedAt: z.string().nullable(),
    })
    .nullable(),
};
